import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** "INVENTORY DATA · CI Level: … · CI Reference: …" above the field grid. */
@Component({
  selector: 'ui-meta-strip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-meta-strip.component.html',
})
export class UiMetaStripComponent {
  /** Hidden for plots and houses, which have no CI level in the reference. */
  readonly ciLevel = input<string>('');
  readonly ciReference = input.required<string>();
}
